/**
 * GalleryModal - Galeria de Imagens - extraído VERBATIM de ProductsContent.js (Fase 2 refactor).
 * Recebe estado/handlers via props do closure de ProductsContent.
 */
import React from 'react';
import { Image as ImageIcon } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';

const GalleryModal = ({
  showGalleryModal,
  setShowGalleryModal,
  galleryImages,
  galleryCategories,
  galleryFilter,
  setGalleryFilter,
  gallerySearch,
  setGallerySearch,
  loadGalleryImages,
  loadingGallery,
  selectGalleryImage,
  loading,
}) => {
  return (
      <Dialog open={showGalleryModal} onOpenChange={setShowGalleryModal}>
        <DialogContent
          data-testid="gallery-modal"
          closeButtonTestId="gallery-modal-close-button"
          className="glass-modal max-w-3xl max-h-[80vh] overflow-hidden flex flex-col"
          onCloseAutoFocus={(e) => e.preventDefault()}
        >
          <DialogHeader>
            <DialogTitle className="text-white text-xl">Galeria de Imagens</DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4 flex-1 overflow-hidden flex flex-col">
            {/* Filtros */}
            <div className="flex gap-3">
              <select
                data-testid="gallery-category-filter"
                value={galleryFilter}
                onChange={(e) => {
                  setGalleryFilter(e.target.value);
                  loadGalleryImages(e.target.value, gallerySearch);
                }}
                className="glass-input px-3 py-2 text-sm"
              >
                <option value="">Todas categorias</option>
                {galleryCategories.map(cat => (
                  <option key={cat} value={cat}>{cat}</option>
                ))}
              </select>
              <input
                type="text"
                data-testid="gallery-search-input"
                placeholder="Buscar..."
                value={gallerySearch}
                onChange={(e) => {
                  setGallerySearch(e.target.value);
                  loadGalleryImages(galleryFilter, e.target.value);
                }}
                className="glass-input flex-1 px-3 py-2 text-sm"
              />
            </div>

            {/* Grid de Imagens */}
            <div className="flex-1 overflow-y-auto">
              {loadingGallery ? (
                <div className="flex items-center justify-center py-8">
                  <div className="loading-spinner"></div>
                </div>
              ) : galleryImages.length === 0 ? (
                <div className="text-center py-8 text-gray-400">
                  <ImageIcon size={48} className="mx-auto mb-2 opacity-50" />
                  <p>Nenhuma imagem encontrada</p>
                  <p className="text-xs mt-1">A galeria será preenchida pelo administrador</p>
                </div>
              ) : (
                <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
                  {galleryImages.map(image => (
                    <div
                      key={image.id}
                      data-testid={`gallery-image-${image.id}`}
                      onClick={() => selectGalleryImage(image.image_url)}
                      className="group relative aspect-square rounded-lg overflow-hidden border-2 border-transparent hover:border-green-500 cursor-pointer transition-all"
                    >
                      <img
                        src={image.image_url}
                        alt={image.name}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center p-2">
                        <p className="text-white text-xs font-medium text-center line-clamp-2">{image.name}</p>
                        <p className="text-green-400 text-[10px] mt-1">Clique para usar</p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>

  );
};

export default GalleryModal;
